function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.125 3.75H5.75V0.375C5.75 0.1875 5.5625 0 5.375 0H4.625C4.41406 0 4.25 0.1875 4.25 0.375V3.75H0.875C0.664062 3.75 0.5 3.9375 0.5 4.125V4.875C0.5 5.08594 0.664062 5.25 0.875 5.25H4.25V8.625C4.25 8.83594 4.41406 9 4.625 9H5.375C5.5625 9 5.75 8.83594 5.75 8.625V5.25H9.125C9.3125 5.25 9.5 5.08594 9.5 4.875V4.125C9.5 3.9375 9.3125 3.75 9.125 3.75Z",
  fill: "#2B82F7"
});

var SvgIcnPlus10Px9Px = function SvgIcnPlus10Px9Px(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnPlus10Px9Px, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn-plus-10px-9px.ed96090b.svg";
export { ForwardRef as ReactComponent };